<!-- VapiEmbed.vue -->
<template>
  <div>
    <div v-if="creating">
      Carregando...
    </div>
    <div v-else>
      <IntervoiceSpeaker
        :level="volumeLevel"
        class="mb-3" />

      <div
        class="alert alert-secondary mb-3 p-3"
        v-if="status === 'sound-test'">
        <div class="mb-2"><b>Teste de som.</b></div>
        <p>Diga se você está ouvindo bem e se podemos prosseguir.</p>
        <button
          class="btn btn-light"
          @click="testAgain">Testar som novamente</button>
      </div>

      <div
        v-if="message && message.text"
        class="alert mb-3"
        :class="`alert-${message.type}`">{{ message.text }}</div>

      <button
        class="btn btn-danger"
        @click="stopCall">Sair da reunião</button>
    </div>
  </div>
</template>

<script>
import Vapi from '@vapi-ai/web'
import config from '../../config.js'
import IntervoiceSpeaker from './IntervoiceSpeaker.vue'

export default {
  name: 'IntervoiceVoice',
  components: {
    IntervoiceSpeaker
  },
  props: {
    globalPrompt: {
      type: String,
      default: null
    },
    startPrompt: {
      type: String,
      default: null
    },
    totalTimeSeconds: {
      type: Number,
      default: 0
    },
    token: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      status: null,
      message: '',
      publicKey: '5489bc0e-6440-43c0-ac98-112e354306f1',
      creating: true,
      volumeLevel: 0,
      interval: null,
      startTimestamp: null,
      timer: 0,
      vapiInstance: null,
      myAssistant: {
        // "id": "010ee85d-b4c5-425d-a63e-d40302fb9438",
        // orgId: '0c971e3d-b366-44cd-9947-430691ffd397',
        name: 'Morgan 2',
        // voice: {
        //  voiceId: 'Elliot',
        //  provider: 'vapi'
        // },
        voice: {
          voiceId: 'Elliot',
          provider: 'vapi'
        },
        // voice: {
        //   model: 'eleven_turbo_v2_5',
        //   // speed: 0.9,
        //   // style: 0.5,
        //   // ohZOfA9iwlZ5nOsoY7LB - mulher
        //   // bJrNspxJVFovUxNBQ0wh - Marcelo Costa_Brasileiro
        //   // Hmn4B9B77pf6ttydteJ8 - Kaique
        //   voiceId: 'bJrNspxJVFovUxNBQ0wh',
        //   provider: '11labs',
        //   stability: 0.5,
        //   similarityBoost: 0.75
        //   // useSpeakerBoost: true,
        //   // optimizeStreamingLatency: 2
        // },
        // voice: {
        //   voiceId: 'Neha',
        //   provider: 'vapi'
        // },
        // voice: {
        //   model: 'eleven_turbo_v2_5',
        //   speed: 0.92,
        //   // style: 0.5,
        //   voiceId: 'Hmn4B9B77pf6ttydteJ8',
        //   provider: '11labs',
        //   stability: 0.5,
        //   similarityBoost: 0.75
        // },
        model: {
          model: 'gpt-5.6-terra',
          temperature: 0.3,
          provider: 'openai',
          messages: [
            {
              role: 'system',
              content: this.globalPrompt.trim()
            }
          ],
          /*
           * As tools agora ficam inline.
           *
           * async: true porque são client-side:
           * o Vue recebe o tool-calls e executa a ação.
           */
          tools: [
            {
              type: 'function',
              async: true,
              function: {
                name: 'audioIsOk',
                description:
                  'Use esta ferramenta quando o usuário confirmar que está ouvindo o áudio corretamente e que podemos prosseguir com a entrevista.',
                parameters: {
                  type: 'object',
                  properties: {},
                  required: []
                }
              }
            },
            {
              type: 'function',
              async: true,
              function: {
                name: 'finishInterview',
                description:
                  'Use esta ferramenta quando a entrevista estiver concluída e for o momento de encerrar a chamada.',
                parameters: {
                  type: 'object',
                  properties: {},
                  required: []
                }
              }
            }
          ]
        },
        firstMessage: 'Olá, você está me ouvindo bem? Podemos começar?',
        // voicemailMessage: 'Please call back when you\'re available.',
        // endCallMessage: 'Goodbye.',
        transcriber: {
          eotTimeoutMs: 4000,
          eotThreshold: 0.7,
          language: 'pt', // -BR
          model: 'flux-general-multi',
          provider: 'deepgram'
        },
        // backgroundSound: 'https://quickin-common-files.s3.sa-east-1.amazonaws.com/indian-office-ambience-4-135825.mp3',
        silenceTimeoutSeconds: 300, // 5 minutos
        maxDurationSeconds: 1800, // 30 minutos
        startSpeakingPlan: {
          waitSeconds: 4
        },

        // stopSpeakingPlan: {
        //   voiceSeconds: 0.3
        // }
        /*
         * Eventos enviados para o BACKEND.
         */
        metadata: {
          token: this.token
        },
        server: {
          // url: `${config.api_url_tunnel}/callback/vapi/events?token=${this.token}`,
          url: `${config.api_url_tunnel}/callback/vapi/events`,
          timeoutSeconds: 20
        },
        serverMessages: [
          'end-of-call-report'
        ],
        /*
         * Eventos enviados para o CLIENTE / Web SDK.
         */
        clientMessages: [
          'tool-calls',
          'speech-update'
        ]
        // isServerUrlSecretSet: false
      }
    }
  },
  computed: {
  },
  mounted () {
    this.start()
  },
  watch: {
  },
  methods: {
    async addMessage (content, role = 'system') {
      // console.log('Enviando mensagem.')

      await this.vapiInstance.send({
        type: 'add-message',

        message: {
          role,
          content
        }
      })
    },

    stopCall () {
      if (
        this.vapiInstance &&
        this.vapiInstance.stop
      ) {
        this.vapiInstance.stop()
      }
    },
    testAgain () {
      this.addMessage(
        'Ainda não estou ouvindo.',
        'user'
      )

      this.addMessage(
        'Pergunte novamente se o usuário esta ouvindo bem.'
      )
    },
    onToolCalls (msg) {
      /*
       * SDK atual utiliza toolCallList.
       *
       * Deixei toolCalls como fallback para
       * compatibilidade com o formato que você
       * já estava usando.
       */
      const toolCalls =
        msg.toolCallList ||
        msg.toolCalls ||
        []

      if (toolCalls.length === 0) {
        return
      }

      toolCalls.forEach(toolCall => {
        const functionName =
          toolCall.function
            ? toolCall.function.name
            : null

        const callArgs =
          toolCall.function
            ? toolCall.function.arguments
            : {}

        console.log({
          functionName,
          callArgs
        })

        if (functionName === 'audioIsOk') {
          this.status = 'conversing'

          this.addMessage(
            this.startPrompt
          )

          this.startTimer()
        }

        if (functionName === 'finishInterview') {
          this.stopCall()
        }
      })
    },
    onSpeechUpdate (role, status) {
      // console.log('onSpeechUpdate', role, status)

      if (status === 'stopped') {
        if (
          role === 'user' &&
          this.status === 'conversing'
        ) {
          this.addMessage(
            `Cronometo: ${this.timer}s de ${this.totalTimeSeconds}s.`
          )
        }
      }
    },
    async start () {
      /*
       * SDK oficial.
       *
       * Antes:
       *
       * window.vapiSDK.run(...)
       *
       * Agora:
       *
       * new Vapi(publicKey)
       */
      this.vapiInstance =
        new Vapi(this.publicKey)

      this.vapiInstance.on(
        'call-start',
        () => {
          console.log(
            'ON :: Call started'
          )

          this.status = 'sound-test'
          this.creating = false
        }
      )

      this.vapiInstance.on(
        'call-end',
        (...args) => {
          console.log(
            'ON :: Call ended',
            args
          )

          this.$emit('finished')
        }
      )

      this.vapiInstance.on(
        'volume-level',
        (volumeLevel) => {
          this.volumeLevel =
            volumeLevel
        }
      )

      this.vapiInstance.on(
        'message',
        (msg) => {
          if (
            msg.type === 'tool-calls'
          ) {
            this.onToolCalls(msg)
          }

          if (
            msg.type === 'speech-update'
          ) {
            this.onSpeechUpdate(
              msg.role,
              msg.status
            )
          }

          console.log(
            '[Vapi MESSAGE]',
            msg
          )
        }
      )

      // this.vapiInstance.on('error', (err) => {
      //   console.error('[Vapi ERROR]', err)
      // })

      console.log(
        'this.myAssistant',
        this.myAssistant
      )
      await this.vapiInstance.start(
        this.myAssistant
      )
    },
    startTimer () {
      this.startTimestamp =
        Date.now()

      this.interval =
        setInterval(() => {
          this.timer =
            Math.floor(
              (
                Date.now() -
                this.startTimestamp
              ) / 1000
            )
        }, 1000)
    }
  }
}
</script>

<style>
</style>
